import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "tss-react/mui";

import { Input } from "@mui/material";

import numberInputStyle from "../../assets/jss/material-dashboard-pro-react/components/numberInputStyle";

//Custom number input met de mogelijkheid om prefix toe toevoegen en suffix
//Door de extra hidden input wordt die niet mee gegeven aan de database.
//TODO
// Negatief mogelijk of niet

class NumberInput extends React.Component {
  state = {
    isEditing: false,
    value: this.props.value,
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.value !== this.props.value) {
      this.setState({ value: this.props.value });
    }
  }

  toggleEditing() {
    this.setState({ isEditing: !this.state.isEditing });
  }

  handleChange = (event) => {
    let value = this.convertInput(event.target.value);

    let returnData = {
      value: value,
      name: this.props.name,
    };

    if (this.props.type === "valuta") {
      returnData["currency"] = this.props.currency;
    }

    //Als de value niet is veranderd dan niks doen.
    if (value !== this.state.value) {
      this.setState({ value: value });

      if (this.props.onChange) {
        this.props.onChange(returnData);
      }
    }
  };

  convertInput(input) {
    //String van maken anders crast de index of
    let output = String(this.state.value);

    let re = null;
    if (this.props.allowMinValue) {
      re = /^\-?[0-9\b\.\,]+$/;
    } else {
      re = /^[0-9\b\.\,]+$/;
    }

    if (input == "" || re.test(input)) {
      output = input;
    }

    switch (this.props.type) {
      case "number":
      case "valuta":
        /**
         * Komma's vervangen door punten
         */
        output = output.replace(/\,/g, ".");
        if ((output.match(/\./g) || []).length > 1) {
          output = output.slice(0, -1);
        }
        break;
    }

    /**
     * Check op maximaal aantal decimalen
     */
    if (this.props.decimalen > 0 && output.indexOf(".") !== -1) {
      let frags = output.split(".");
      let indexKey = output.indexOf(".");
      if (frags[1].length > this.props.decimalen) {
        output = output.slice(0, -1);
      }
    }

    /**
     * Als laatste cijfer een . is dan die weghalen
     * Alleen als decimalen 0 is
     */
    if (this.props.decimalen === 0 && output.indexOf(".") !== -1 && output.indexOf(".") === output.length - 1) {
      output = output.slice(0, -1);
    }

    return output;
  }

  convertData(number) {
    let output = "";

    switch (this.props.type) {
      case "valuta":
        const formatter = new Intl.NumberFormat("nl-NL", {
          style: "currency",
          currency: this.props.currency ? this.props.currency : "EUR",
          currencyDisplay: "symbol",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

        output = formatter.format(number);
        break;

      default:
        output = number;
        break;
    }

    return output;
  }

  render() {
    const { classes } = this.props;

    let prefix = this.props.prefix !== undefined ? this.props.prefix : "";
    let suffix = this.props.suffix !== undefined ? this.props.suffix : "";

    return [
      <input key={"maininput"} name={this.props.name} type={"hidden"} value={this.props.value} />,
      this.state.isEditing ? (
        <Input
          autoFocus
          className={classes.mainInput}
          id={this.props.id}
          inputProps={this.props.inputProps}
          key={"editinput"}
          onBlur={this.toggleEditing.bind(this)}
          onChange={this.handleChange}
          value={this.state.value}
        />
      ) : (
        <Input
          className={classes.mainInput}
          id={this.props.id}
          inputProps={this.props.inputProps}
          key={"input"}
          onFocus={this.toggleEditing.bind(this)}
          value={prefix + this.convertData(this.state.value) + suffix}
        />
      ),
    ];
  }
}

NumberInput.defaultProps = {
  type: "number",
  decimalen: 2,
};

NumberInput.propTypes = {
  type: PropTypes.oneOf(["valuta", "number"]),
  decimalen: PropTypes.number,
  name: PropTypes.string,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  onChange: PropTypes.func,
  allowMinValue: PropTypes.bool,
};

export default withStyles(NumberInput, numberInputStyle);
